import React from "react";
import getClassNames from "../../Utils/getClassNames";
import Loader from "./Loader";

export default function Button({text, onClick, className, type, 
        disabled, loading, id, href, target, icon, iconLocation}) {
    const handleOnClick = () => {
        if (onClick) {
            onClick();
        }
    };

    if(href) {
        <a id={id} href={href} className={getClassNames('btn', className)} target={target} onClick={handleOnClick}>
            {text}
            {icon || null}
        </a>
    }

    iconLocation = iconLocation || 'end';

    return (
        <button id={id} className={getClassNames('btn', className)} type={type || 'button'} disabled={disabled} onClick={handleOnClick}>
            {iconLocation === 'start' && icon}
            {text}
            {iconLocation === 'end' && icon}
            {loading && <Loader />}
      </button>
    )
}